import script from "./NodeDelaySummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./NodeDelaySummary.vue?vue&type=script&setup=true&lang=ts"

import "./NodeDelaySummary.vue?vue&type=style&index=0&id=b7f1fad8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7f1fad8"]])

export default __exports__